module.exports = __webpack_public_path__ + "img/weiyue.bbbdfd7a.png";